import type { Lang } from '@/types/lang';
import { LANGS } from '@/types/lang';

const STORAGE_KEY = 'gendent.lang';

export function detectDefaultLang(): Lang {
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && (LANGS as readonly string[]).includes(stored)) return stored as Lang;

    const nav = navigator.language ?? '';
    if (nav.toLowerCase().startsWith('zh')) return 'cn';
    if (nav.toLowerCase().startsWith('en')) return 'en';
  }
  return 'cn';
}

export function setLang(lang: Lang): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, lang);
  }
}

export function langFromPathname(pathname: string): Lang | null {
  if (pathname.startsWith('/cn')) return 'cn';
  if (pathname.startsWith('/en')) return 'en';
  return null;
}
